import count from '@/api/stock/stock-count'
import moment from 'moment'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  products: [],
  location_id: [],
  dateRange: [
    moment().add(-7, 'days').format('DD-MM-YYYY'),
    moment().format('DD-MM-YYYY')
  ]
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_DATE_RANGE (state, date) {
    state.dateRange = date
  },
  SET_PRODUCT (state, data) {
    state.products = data
  },
  SET_USER (state, data) {
    state.users = data
  },
  CLEAR_SETUP (state) {
    state.products = []
  },
  SET_LOCATION_ID (state, data) {
    state.location_id = data
  }
}

export const actions = {
  fetch (context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        branch_id: context.state.branch_id,
        location_id: context.state.location_id,

        filter: {
          search: context.state.search,
          date_between: _.join(context.state.dateRange, ',')
        }
      },
      attrubutes
    )
    return count.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  store (context, data) {
    return count.store(data)
  },
  update (context, { id, data }) {
    return count.update(id, data)
  },
  async find (context, id) {
    if (_.isEmpty(context.state.edit_data)) {
      let response = await count.find(id)
      context.commit('SET_EDIT_DATA', response.data)
    }
  },
  destroy (context, id) {
    return count.destroy(id)
  },
  getUser (context) {
    return count.user()
  },
  generate (context, data) {
    return count.generate(data)
  },
  async fetchResource (context) {
    let var_product = await count.product()
    context.commit('SET_PRODUCT', var_product.data)
  },
  exportExcel (context, data) {
    return count.exportExcel(data)
  },
  importExcel(context, data) {
    return count.importExcel(data)
  },
}
